<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-organization-phone" class="control-label">{{ inputLabel }}</label>
    <phone-input
      id="form-organization-phone"
      :disabled="disabled"
      v-model="inputValue"
      :placeholder = "'+7 812 345-67-89'"
      @input="emitValue('input', $event)"
      @change="emitValue('change', $event)"
      @blur="emitValue('blur', $event)"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import organizationSectionMixin from '../../../../mixins/application-form/organizationSectionMixin'
import organizationInputMixin from '../../../../mixins/application-form/organizationInputMixin'
import PhoneInput from '../../../inputs/PhoneInput.vue'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'OrganizationPhoneInput',

  components: {
    Hint,
    PhoneInput
  },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    organizationSectionMixin,
    organizationInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Телефон'
    },

    inputName: {
      default: 'phone'
    },

    inputHint: {
      default: undefined
    }
  }
}
</script>
